(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('complete-your-ritual')) {
    customElements.define('complete-your-ritual', class CompleteYourRitual extends HTMLElement {
      connectedCallback() {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 300px 0px' });

        this.observer.observe(this);
      }

      async loadRecommendations() {
        try {
          const complementaryMarkup = await this.fetchRecommendations(this.dataset.complementaryUrl);
          if (this.renderRecommendations(complementaryMarkup)) return;

          const relatedMarkup = await this.fetchRecommendations(this.dataset.relatedUrl);
          this.renderRecommendations(relatedMarkup);
        } catch (error) {
          console.error(error);
        }
      }

      async fetchRecommendations(url) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
        return response.text();
      }

      renderRecommendations(markup) {
        const html = document.createElement('div');
        html.innerHTML = markup;
        const content = html.querySelector('[data-ritual-content]');

        if (!content || !content.innerHTML.trim()) return false;

        this.innerHTML = content.outerHTML;
        this.classList.add('ritual-recommendations--loaded');
        return true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
